import React, { useEffect, useMemo, useRef } from 'react'

import { Column, Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

import Carousel from './Carousel'
import Overlay from './ConnectionLinesOverlay'
import {
  ACCESS_SECTION_GALLERY_ITEMS,
  LearnSectionGalleryItemId,
} from './constants'
import ImageHolder from './ImageHolder'
import { GridContainer } from './styles'
import { useConnectionLines } from './useConnectionLines'
import { useRefMap } from './useRefMap'

function LearnSectionGallery() {
  const { isDesktop } = useResponsiveLayout()

  const containerRef = useRef<HTMLDivElement>(null)
  const { refMap, setRef } = useRefMap<LearnSectionGalleryItemId>()
  const { lines, updateLines } = useConnectionLines(refMap, containerRef)

  const items = useMemo(
    () =>
      ACCESS_SECTION_GALLERY_ITEMS.sort((a, b) =>
        isDesktop
          ? a.desktopOrder - b.desktopOrder
          : a.mobileOrder - b.mobileOrder,
      ),
    [isDesktop],
  )

  useEffect(() => {
    requestAnimationFrame(() => {
      updateLines()
    })
  }, [updateLines, isDesktop])

  return isDesktop ? (
    <GridContainer ref={containerRef}>
      {items.map(item => (
        <Column alignCenter gap={4} key={item.id} relative>
          <ImageHolder data={item} ref={setRef(item.id)} />

          <Text accent center medium preWrap screen14>
            {item.caption}
          </Text>
        </Column>
      ))}

      <Overlay lines={lines} />
    </GridContainer>
  ) : (
    <Carousel items={items} />
  )
}

export default LearnSectionGallery
